import { Theme } from "@mui/material/styles";
import { SxProps } from "@mui/material";
import React from "react";
import theme from "@/theme";

export const stylesPaidContentLine = {
  container: {
    cursor: "ns-resize",
    width: "100%",
    margin: "0 auto",
    position: "absolute",
    top: 100,
    left: "50%",
    transform: "translateX(-50%)",
    height: "4px",
    zIndex: 1000,
    marginTop: "1px",
  } as SxProps<Theme>,

  line: (togglePaidContent: boolean, theme: Theme): SxProps<Theme> => ({
    marginTop: "3px",
    height: "1px",
    width: "100%",
    bgcolor: togglePaidContent ? theme.palette.custom.mainBlue : "#D9D9D9",
  }),

  mainButton: (togglePaidContent: boolean, theme: Theme): SxProps<Theme> => ({
    minWidth: "fit-content",
    height: "40px",
    textTransform: "none",
    bgcolor: togglePaidContent ? theme.palette.custom.mainBlue : "#F4F5F6",
    width: "318px",
    position: "relative",
    bottom: "18px",
    zIndex: "1000",
    color: togglePaidContent ? theme.palette.custom.mainWhite : "#2A2D31",
    borderRadius: "22px",
    padding: "10px 16px",
    fontFamily: "Inter",
    fontWeight: "500",
    fontStyle: "Medium",
    fontSize: "14px",
    lineHeight: "20px",
    textAlign: "center",
  }),

  buttonInnerBox: {
    marginLeft: "20px",
    height: "20px",
    textAlign: "center",
    display: "flex",
    justifyContent: "center",
  } as SxProps<Theme>,

  setPriceText: (togglePaidContent: boolean, theme: Theme): SxProps<Theme> => ({
    margin: "0",
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "20px",
    color: togglePaidContent ? theme.palette.custom.mainWhite : theme.palette.custom.mainBlue,
  }),

  expandedContainer: (theme: Theme): SxProps<Theme> => ({
    margin: "0 auto",
    height: "302px",
    borderBottom: "1px solid " + theme.palette.custom.mainBlue,
  }),

  priceLabelSvg: {
    width: "46px",
    height: "46px",
  } as React.CSSProperties,

  inputWrapper: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    height: "72px",
    maxWidth: 400,
    gap: "10px",
  } as SxProps<Theme>,

  helperTextStyles: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "12px",
    lineHeight: "14px",
    letterSpacing: "0%",
    color: "#7D8690",
  },

  sectionHintTextStyles: {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "24px",
    letterSpacing: "-1%",
    color: theme.palette.custom.mainBlue,
    whiteSpace: "nowrap",
  },

  mainInput: {
    flex: 1,
    "& .MuiOutlinedInput-root": {
      minWidth: "347px",
      width: "347px",
      height: "48px",
      borderRadius: "30px",
      paddingRight: 0,
      backgroundColor: "#FFFFFF",
      border: "1px solid #4285f4",
      outline: "none",
      "&:hover": { border: "1px solid #4285f4" },
      "&.Mui-focused": { border: "1px solid #4285f4", outline: "none" },
      "& fieldset": { border: "none !important" },
      "&:hover fieldset": { border: "none !important" },
      "&.Mui-focused fieldset": { border: "none !important" },
    },
    "& .MuiOutlinedInput-input": {
      padding: "14px 16px",
      fontFamily: "Inter",
      fontWeight: 500,
      fontStyle: "normal",
      fontSize: "16px",
      lineHeight: "150%",
      letterSpacing: "0%",
      color: "#000000",
    },
  } as SxProps<Theme>,

  applyButton: {
    backgroundColor: "#4285F4",
    color: "#FFFFFF",
    margin: "4px",
    height: "40px",
    borderRadius: "26px",
    padding: "10px 24px",

    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "16px",
    letterSpacing: "0%",
    textTransform: "none",

    boxShadow: "none",

    "&:hover": {
      backgroundColor: "#3367D6",
      boxShadow: "none",
    },

    "&.Mui-disabled": {
      backgroundColor: "#8BC5F4",
      color: "#FFFFFF",
      opacity: 1,
    },
  } as SxProps<Theme>,

  optionalInput: {
    width: "9.75rem",
    height: "2.625rem",
    borderRadius: "0.5rem",
    marginTop: "0.75rem",
    "& .MuiOutlinedInput-root": {
      borderRadius: "0.5rem",
      fontSize: "14px",
      height: "100%",
      paddingRight: "8px",
    },
  } as SxProps<Theme>,

  doneButton: {
    borderRadius: "0.5rem",
    marginTop: "1.5rem",
    marginBottom: "3rem",
  } as SxProps<Theme>,

  blurOverlay: (lineY: number): React.CSSProperties => ({
    position: "absolute",
    top: `${lineY + 4}px`,
    height: "auto",
    left: "-50vw",
    right: "-50vw",
    bottom: 0,
    backdropFilter: "blur(5px)",
    WebkitBackdropFilter: "blur(5px)",
    clipPath: "inset(0)",
    pointerEvents: "none",
    zIndex: 999,
  }),
  containerTitle: {
    marginTop: "40px",
    width: "709px",
    height: "auto",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },

  title: {
    fontFamily: "Inter",
    fontWeight: 600,
    fontStyle: "normal",
    fontSize: "16px",
    lineHeight: "20px",
    letterSpacing: "0%",
    textAlign: "center",
    verticalAlign: "middle",
  },

  containerSwich: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: "14px",
  } as SxProps<Theme>,

  formControlLabel: {
    width: 347,
    margin: 0,

    "& .MuiFormControlLabel-label": {
      marginRight: "16px",
    },
  } as SxProps<Theme>,

  labelText: {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "24px",
    letterSpacing: "-0.01em",
    color: "#33383F",
  } as SxProps<Theme>,

  customSwitch: {
    width: 48,
    height: 24,
    padding: "0px",
    borderRadius: "32px",

    "& .MuiSwitch-switchBase": {
      padding: "2px",
      backgroundColor: "transparent",

      "&:hover": {
        backgroundColor: "transparent",
      },

      "&.Mui-checked": {
        transform: "translateX(24px)",
        color: "#FFFFFF",

        "&:hover": {
          backgroundColor: "transparent",
        },

        "& + .MuiSwitch-track": {
          opacity: 1,
        },
      },
    },

    "& .MuiSwitch-thumb": {
      width: 20,
      height: 20,
      borderRadius: "24px",
      backgroundColor: "#FFFFFF",
      border: "1px solid #ECECEC",
      boxShadow: "0px 0px 4px 0px #00000033",
    },

    "& .MuiSwitch-track": {
      opacity: 1,
      backgroundColor: "#F4F4F4",
      border: "1px solid #D5D8DB",
      borderRadius: "32px",
    },
  } as SxProps<Theme>,
};
